<template>
  <div v-show="show" class="yxy-progress">
    <div class="yxy-progress-bar">
      <div class="yxy-progress-inner-bar js-progress" :style="{width: percent + '%'}"></div>
    </div>
  </div>
</template>

<script>
import Tween from '../../utils/tween'

export default {
  name: 'y-progress',
  props: {
    value: Number,
    time: {
      type: Number,
      default: 100
    }
  },
  mounted () {
    this.show = true
    this.ainimate()
  },
  data () {
    return {
      show: false,
      percent: 0
    }
  },
  watch: {
    value (val) {
      if (val) {
        this.percent = val
      }
    },
    percent (val) {
      this.$emit('input', val)
      if (val === 100) {
        this.show = false
      }
    }
  },
  // created () {
  //   console.log(this.value)
  //   this.percent = this.value || 0
  // },
  methods: {
    ainimate () {
      let t = 0
      let b = 0
      let c = 100
      let d = this.time
      let progress = 0
      let loopId = null
      let self = this
      function loop () {
        if (t < d - 3) {
          t++
          progress = Tween.Quart.easeIn(t, b, c, d)
          self.percent = Math.ceil(progress)
          clearTimeout(loopId)
          loopId = setTimeout(loop, 10)
        } else {
          clearTimeout(loopId)
        }
      }
      setTimeout(loop, 0)
    }
  }
}
</script>
